// ##### 23-03-29 Komarov
import axios from 'axios';
// ##### Komarov 2025-07-12
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
// ##### 25-01-01 Komarov
import { isBrowser } from '../../../../server/helpers/browserDetector';

// ##### Komarov 2025-07-14
const IncompleteSendEmail = ({
  smartServiceDataErrorMessage,
  smart_service_id,
  cart,
  watchedFormData,
}) => {
  // TODO: Передать сюда объект cart
  // console.log('IncompleteSendEmail-cart: ', cart)
  const { user: currentUser } = useSelector(state => state.auth);
  // ##### 24-08-05 Komarov
  const company_id = useSelector(state => state.auth.user.company_id);

  const {
    buyerPrefix,
    buyerFirstName,
    buyerLastName,
    buyerPhone,
    buyerEmail,
    travelersData,
  } = watchedFormData;

  const travelersObject = {};

  travelersData.forEach(traveler => {
    travelersObject[`Traveler ${traveler.site_client_id} prefix`] =
      traveler.travelerPrefix;
    travelersObject[`Traveler ${traveler.site_client_id} name`] =
      traveler.travelerFirstName;
    travelersObject[`Traveler ${traveler.site_client_id} surname`] =
      traveler.travelerLastName;
    travelersObject[`Traveler ${traveler.site_client_id} category`] =
      traveler.travelerCategory;
  });

  // ##### Komarov 2025-07-21
  const data = {
    City: decodeURIComponent(cart?.cityName),
    Hotel: cart?.htlName || 'No info',
    Room: cart?.room_name || 'No info',
    Tariff: cart?.tariff_type_name || 'No info',
    NRF: cart?.nrf || 'No info',
    Adults: cart?.adults || 'No info',
    Children: cart?.children || 'No info',
    Amount: cart?.amount || 'No info',
    Currency: cart?.selected_currency || 'No info',
    Start: cart?.start || 'No info',
    End: cart?.end || 'No info',
    'Number of Rooms': cart?.numberofunits || 'No info',
    "Buyer's prefix": buyerPrefix,
    "Buyer's name": buyerFirstName,
    "Buyer's surname": buyerLastName,
    "Buyer's phone": buyerPhone,
    "Buyer's email": buyerEmail,
    ...travelersObject,
  };

  // ##### Komarov 2025-07-12
  useEffect(() => {
    if (smartServiceDataErrorMessage.length > 0) return;
    const ActionRQ = {
      username: process.env.REACT_APP_SMART_USERNAME,
      password: process.env.REACT_APP_SMART_PASSWORD,
      user_id: currentUser.user_id,
      // ##### 24-08-05 Komarov
      refpartner: company_id,
      action: 'ModifyClientsRQ',
      smart_service_id,
      service_number: 1,
      ...data,
    };

    // ##### 23-01-31 Komarov: исправил адрес системки отправки почты на актуальный
    axios.post(
      // ##### 26-07-30 Komarov
      `${process.env.REACT_APP_URL}online_summary_incomplete`,
      // ##### Komarov 2025-09-23
      JSON.stringify({ ActionRQ, arkturSiteB: isBrowser ? 1 : 0 }),
      // ##### Komarov 2025-07-07
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    // ##### 24-03-21 Komarov
    /* .then(response => {
                // console.log('RESPONSE', response)
                // setSendCart(response.data[0])
            })
            .catch(error =>{
                // setSendCart(undefined)
                // console.log('[axios error]: ', error)
            }); */
    // ##### 23-04-12 Komarov
  }, [
    currentUser.user_id,
    smart_service_id,
    buyerPrefix,
    buyerFirstName,
    buyerLastName,
    buyerPhone,
    buyerEmail,
    cart?.cityName,
    cart?.htlName,
    cart?.room_name,
    cart?.tariff_type_name,
    cart?.nrf,
    cart?.adults,
    cart?.children,
    cart?.amount,
    cart?.start,
    cart?.end,
    cart?.numberofunits,
    travelersData.length,
  ]);

  // console.log('ModifyClientsRQ_Add',ModifyClientsRQ_Add)

  return <>{/* <div>Email sent.</div> */}</>;
};

export default IncompleteSendEmail;
